module.exports = __webpack_public_path__ + "img/searchsz.b1ef6d00.svg";